import React from "react";
import { Folder } from "@material-ui/icons";
import { useMediaLibraryModalStyles } from "../utils/styles";

const MediaStats = ({ stats, resources }) => {
	const classes = useMediaLibraryModalStyles();

	return (
		<div className={classes.headerStats}>
			<Folder className={classes.statsIcon} />
			<div className={classes.statsText}>
				<div className={classes.statsNumbers}>
					{stats.total} {resources["Attachments"]}
				</div>
				<div className={classes.statsDetails}>
					{stats.details.length > 0
						? stats.details.join(" • ")
						: resources["NoFilesUploaded"] || "No files"}
				</div>
			</div>
		</div>
	);
};

export default MediaStats;
